
import {
  apiAiCallLists,
  apiAiCallAdd,
  apiAiCallEdit,
  apiAiCallDel,
  apiAiCateList,
} from "@/api/setting";
import { Component, Prop, Vue } from "vue-property-decorator";
import LsPagination from "@/components/ls-pagination.vue";
import { RequestPaging } from "@/utils/util";
import LsDialog from "@/components/ls-dialog.vue";
import LsForm from "@/components/ls-form.vue";
import MaterialSelect from "@/components/material-select/index.vue";
import PromotCommon from "@/components/promot-common.vue";

@Component({
  components: {
    LsDialog,
    LsPagination,
    LsForm,
    MaterialSelect,
    PromotCommon,
  },
})
export default class AiActionList extends Vue {
  // 分页
  pager: RequestPaging = new RequestPaging();
  apiAiCallLists = apiAiCallLists;
  searchObj: any = {
    title: "",
    status: "",
  };
  mode = "add";
  dataForm: any = {
    title: "",
    content: "",
    category: "",
    status: 1,
    sort: 0,
    desc: "",
    image: "",
    other: "",
  };
  orignimg = "";
  resultimg = "";
  model_id = null;
  aiCateOptions: any = [];
  formVisible = false;

  // 获取列表
  getList() {
    this.pager.request({
      callback: apiAiCallLists,
      params: this.searchObj,
    });
  }

  // 获取分类名称
  getCategoryName(type: string) {
    let item = this.aiCateOptions.find((item: any) => item.value == type);
    return item ? item.label : "";
  }

  handleAdd() {
    this.dataForm = {
      title: "",
      content: "",
      category: "",
      status: 1,
      sort: 0,
      desc: "",
      image: "",
      other: "",
    };
    this.mode = "add";
    this.formVisible = true;
  }

  async handleEdit(row: any) {
    this.dataForm = {
      id: row.id,
      title: row.title,
      content: row.content,
      category: row.category,
      status: row.status,
      sort: row.sort,
      desc: row.desc,
      image: row.image,
      other: row.other,
    };
    if (row.other) {
      let other = JSON.parse(row.other);
      this.orignimg = other.orignimg;
      this.resultimg = other.resultimg;
    }
    this.mode = "edit";
    this.formVisible = true;
  }

  handleSortChange(row: any) {
    this.dataForm = {
      id: row.id,
      title: row.title,
      content: row.content,
      category: row.category,
      status: row.status,
      sort: row.sort,
      desc: row.desc,
      image: row.image,
      other: row.other,
    };
    this.mode = "edit";
    this.handleSubmit();
  }

  handleStatusChange(row: any) {
    this.dataForm = {
      id: row.id,
      title: row.title,
      content: row.content,
      category: row.category,
      status: row.status == 1 ? 0 : 1,
      sort: row.sort,
      desc: row.desc,
      image: row.image,
      other: row.other,
    };
    this.mode = "edit";
    this.handleSubmit();
  }

  handleSubmit() {
    let value = this.dataForm;
    let other = {
      orignimg: this.orignimg,
      resultimg: this.resultimg,
    };
    value.other = JSON.stringify(other);
    if (this.mode == "add") {
      apiAiCallAdd(value).then((res: any) => {
        this.getList();
        this.formVisible = false;
      });
    } else {
      apiAiCallEdit(value).then((res: any) => {
        this.getList();
        this.formVisible = false;
      });
    }
  }

  handleDelete(id: number) {
    apiAiCallDel({ id: id }).then((res: any) => {
      this.getList();
    });
  }

  getCateList() {
    apiAiCateList({}).then((res) => {
      this.aiCateOptions = res.map((item: any) => ({
        label: item.name,
        value: item.type,
      }));
    });
  }

  created() {
    this.getCateList();
    this.getList();
  }
}
